import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from '../utils/authUtils';

/**
 * A wrapper component that protects routes requiring authentication
 * Redirects to login page if the user is not authenticated
 */
const ProtectedRoute = () => {
    const auth = isAuthenticated();
    
    // If authenticated, render the child routes
    // Otherwise, redirect to the login page
    return auth ? <Outlet /> : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
